import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ReportsLandingComponent } from './reports-landing/reports-landing.component';
import { ReportDetailedComponent } from './report-detailed/report-detailed.component';
import { ReportEsignComponent } from './report-esign/report-esign.component';
import { ReportEstampComponent } from './report-estamp/report-estamp.component';

const routes: Routes = [

  {
    path: '', pathMatch: 'full', redirectTo: 'reports-listing'
  },
  {
    path: 'reports-listing',
    component: ReportsLandingComponent
  },
  {
    path: 'reports-detailed',
    component: ReportDetailedComponent
  },
  {
    path: 'reports-esign',
    component: ReportEsignComponent
  },
  {
    path: 'reports-estamp',
    component: ReportEstampComponent
  },
  
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ReportsRoutingModule { }
